export default [
    'Asokoro', 'Central Business District', 'Gaduwa', 'Garki I', 'Garki II', 'Gudu', 'Guzape', 'Gwarinpa', 'Jabi', 'Jahi', 'Kado', 'Katampe (Urban Shelter)', 'Life Camp', 'Mabuchi', 'Maitama', 'Utako', 'Wuse zones', 'Wuse II', 'Wuye', 'Karasana', 'Apo'
]
